import { render, staticRenderFns } from "./CampusAutoCompleteDropdown.vue?vue&type=template&id=4c84bcaf&"
import script from "./CampusAutoCompleteDropdown.vue?vue&type=script&lang=js&"
export * from "./CampusAutoCompleteDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports